import {
  combine,
  createEvent,
  createGate,
  createStore,
  restore,
  sample,
} from '@lib/state-engine';
import { removeWarehouseFeatureModel } from '@features/remove-warehouse';
import { warehouseModel } from '@entities/warehouse';
import { map } from './map';
import {
  WAREHOUSES_BAGS_QUERY_NAME,
  WAREHOUSES_ID_QUERY_NAME,
  WAREHOUSES_TYPE_QUERY_NAME,
} from '@@/warehouses/config/query.config';
import {
  IWarehouse,
  WarehouseTypeName,
  IWarehouseWithBags,
  WarehouseTypes,
} from '@@/warehouses/ts';
import { showFillModal } from '@@/agriculture/store/agriculture.store';
import { Sleeve } from '@lib/sleeve-manager';
export const ViewerGate = createGate<{ wh: string | null; z: string | null }>();
export const toggleZoomMode = createEvent<boolean>();
export const selectContextMenu = createEvent();
export const closeContextMenu = createEvent();
export const toggleSelectWarehouse = createEvent<number | null>();
export const selectWarehouse = createEvent<number>();
export const toggleLeftWh = createEvent<{ id: number; name: string } | null>();
export const toggleRightWh = createEvent<{ id: number; name: string } | null>();
export const toggleDetalizationPanel = createEvent<boolean>();
export const addSleeveWarehouse = createEvent();
export const addStationaryWarehouse = createEvent();
export const addedSleeveWarehouse = createEvent();
export const addedStationaryWarehouse = createEvent();
export const mapLoaded = createEvent();
import { DiContainer } from '@@/di/di-container';
import { ClientStorageService } from '@@/common/services/client-storage.service';
import { $selectedViewMode, setViewMode } from '@features/storage-mode-select/model';
import { fetchWarehouseStatByIdFx } from '@entities/warehouse/store';
export const onZoomModeEnter = createEvent<IWarehouseWithBags>();
const onZoomUpdate = createEvent<IWarehouseWithBags>();
const onZoomModeLeave = createEvent();
export const onContextMenu = createEvent<{
  coords: number[];
  id: string;
}>();
const chooseMenuElement = createEvent();
const drawStoresOnMap = createEvent<IWarehouse[]>();
const allStoresDrawed = createEvent();
const clientStorageService = DiContainer.get(ClientStorageService);
export const $viewMode = $selectedViewMode;
export const $zoomModeEnabled = createStore(false)
  .on(onZoomModeEnter, () => {
    return true;
  })
  .reset([ViewerGate.close, onZoomModeLeave]);
export const $contextMenuEnabled = createStore<{
  id: string;
  coords: number[];
  // sleeve: any;
}>({ id: '', coords: [] }).on(onContextMenu, (e, current) => {
  return current;
});
export const $contextMenuStatus = createStore<boolean>(false)
  .on(onContextMenu, () => true)
  .on(closeContextMenu, () => false);
// @ts-ignore
export const $contextMenuCoords = createStore([100, 100]).on(
  onContextMenu,
  (e, data: { coords: number[] }) => {
    return data.coords;
  },
);
export const $isMapLoaded = createStore(false)
  .on(mapLoaded, () => true)
  .reset(ViewerGate.close);
export const $addingWarehouse = createStore(false)
  .on([addSleeveWarehouse, addStationaryWarehouse], () => true)
  .reset([addedSleeveWarehouse, addedStationaryWarehouse]);
export const $addingWarehouseType = createStore<WarehouseTypeName | null>(null)
  .on(addSleeveWarehouse, () => 'sleeve')
  .on(addStationaryWarehouse, () => 'stationary')
  .reset([addedSleeveWarehouse, addedStationaryWarehouse]);
export const $detalizationOpened = restore(toggleDetalizationPanel, false).reset([
  ViewerGate.close,
  removeWarehouseFeatureModel.closeSuccess,
]);
export const $selectedWarehouseId = createStore<number | null>(null)
  .on(toggleSelectWarehouse, (_, p) => {
    if (p) clientStorageService.set('SELECTED_WAREHOUSE_ID', p.toString());
    else clientStorageService.remove('SELECTED_WAREHOUSE_ID');
    return p ?? null;
  })
  .on(selectWarehouse, (_, p) => {
    clientStorageService.set('SELECTED_WAREHOUSE_ID', p.toString());
    return p;
  })
  .reset([ViewerGate.close, removeWarehouseFeatureModel.closeSuccess]);
const leftDefaultState = localStorage.getItem('SELECTED_LEFT_WAREHOUSE');
const rightDefaultState = localStorage.getItem('SELECTED_RIGHT_WAREHOUSE');
export const $selectedLeftWh = createStore<{ id: number; name: string } | null>(
  leftDefaultState ? JSON.parse(leftDefaultState) : null,
).on(toggleLeftWh, (_, p) => {
  // console.log('check ', p)
  if (p) clientStorageService.set('SELECTED_LEFT_WAREHOUSE', JSON.stringify(p));
  else clientStorageService.remove('SELECTED_LEFT_WAREHOUSE');
  return p ?? null;
});
export const $selectedRightWh = createStore<{ id: number; name: string } | null>(
  rightDefaultState ? JSON.parse(rightDefaultState) : null,
).on(toggleRightWh, (_, p) => {
  if (p) clientStorageService.set('SELECTED_RIGHT_WAREHOUSE', JSON.stringify(p));
  else clientStorageService.remove('SELECTED_RIGHT_WAREHOUSE');
  return p ?? null;
});
export const $selectedWarehouseType = createStore<number | null>(null).reset([
  ViewerGate.close,
  removeWarehouseFeatureModel.closeSuccess,
]);
export const selectSleeve = createEvent<string>();
export const $selectedSleeveId = createStore<string | null>(null).reset([
  ViewerGate.close,
  removeWarehouseFeatureModel.closeSuccess,
  toggleSelectWarehouse,
]);
$selectedSleeveId.on(selectSleeve, (_, p) => p);
export const $showZoomButton = combine(
  [
    warehouseModel.$isLoadingWarehouseInfo,
    $selectedWarehouseId,
    $selectedWarehouseType,
  ],
  ([isLoading, id, whType]) =>
    !isLoading && id && whType === warehouseModel.WAREHOUSE_TYPES.sleeve,
);
const $initialSelectedWarehouse = createStore<number | null>(null)
  .on(ViewerGate.open, (_, p) => {
    if (!p.wh) {
      p.wh = clientStorageService.get('SELECTED_WAREHOUSE_ID');
    }
    return p.wh ? Number(p.wh) : null;
  })
  .reset([ViewerGate.close, toggleSelectWarehouse]);
const $initialZoomEnabled = createStore<boolean>(true)
  .on(ViewerGate.open, (_, p) => {
    const zoomMode = clientStorageService.get<boolean>('ZOOM_MODE');
    // return p.z ? Boolean(p.z) : false;
    return !!zoomMode;
  })
  .reset(ViewerGate.close);
const $initialZoomCompleted = createStore<boolean>(false).reset(ViewerGate.close);
toggleSelectWarehouse.watch((whId) => {
  const warehouse = warehouseModel.$allWarehouses
    .getState()
    .find((wh) => wh.id === whId);
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(new URL(currentUrl).search);
  const bags = urlParams.get('bags');
  window.history.pushState(
    null,
    '',
    window.location.pathname +
      (bags
        ? `?${WAREHOUSES_ID_QUERY_NAME}=${whId}&${WAREHOUSES_TYPE_QUERY_NAME}=${warehouse?.type}&${WAREHOUSES_BAGS_QUERY_NAME}=${bags}`
        : `?${WAREHOUSES_ID_QUERY_NAME}=${whId}&${WAREHOUSES_TYPE_QUERY_NAME}=${warehouse?.type}`),
  );
  whId && map.moveToWarehouse(whId);
});
drawStoresOnMap.watch((warehouses) => {
  map.clear();
  // Сначала добавляем все склады
  warehouses.forEach((wh) => {
    map.addWarehouse(
      wh,
      true,
      warehouses.length,
      () => {
        setTimeout(() => toggleSelectWarehouse(Number(wh.id) || null), 300);
      },
      () => {
        if ($selectedWarehouseId.getState() != wh.id) {
          toggleSelectWarehouse(Number(wh.id) || null);
          setTimeout(() => toggleZoomMode(true), 2000);
        } else {
          toggleZoomMode(true);
        }
      },
    );
  });
  // Добавляем проверку координат
  map.checkMarkersCoordinates();
  // Вызываем группировку
  map.groupPlacemarks();

  allStoresDrawed();
});
onZoomModeEnter.watch((wh) => map.enterZoomMode(wh));
onZoomModeLeave.watch(() => map.leaveZoomMode());
onZoomUpdate.watch((wh) => {
  if (wh.removeData) {
    map.removeSleeve(wh.removeData.bagId);
    delete wh.removeData;
    return;
  }
  if (!wh.fillData) {
    map.removeWarehouse(Number(wh.id));
    map.addWarehouse(
      wh,
      false,
      null,
      () => toggleSelectWarehouse(Number(wh.id) || null),
      () => {
        if ($selectedWarehouseId.getState() != wh.id) {
          toggleSelectWarehouse(Number(wh.id) || null);
          setTimeout(() => toggleZoomMode(true), 2000); //TODO поправить костыль. Проблема в том, что после стационарного склада при двойном клике на рукавном не появляется рамка из за того что зум переключается первее чем происходит селект рукавного склада
        } else {
          toggleZoomMode(true);
        }
      },
    );
  }
  map.updateZoomPlacemarks(wh);
});
sample({
  clock: toggleZoomMode,
  source: { data: warehouseModel.$warehouseInfo },
  filter: ({ data }, enter) => enter && data !== null,
  fn: ({ data }) => {
    setViewMode('map');
    clientStorageService.set('ZOOM_MODE', 'enabled');
    return data as IWarehouseWithBags;
  },
  target: onZoomModeEnter,
});
sample({
  clock: toggleZoomMode,
  filter: (enter) => {
    if (!enter) {
      clientStorageService.remove('ZOOM_MODE');
    }
    return !enter;
  },
  target: onZoomModeLeave,
});
sample({
  clock: selectContextMenu,
  filter: () => {
    return true;
  },
  target: chooseMenuElement,
});
sample({
  clock: mapLoaded,
  target: warehouseModel.loadAllWarehouses,
});
sample({
  clock: allStoresDrawed,
  source: $initialSelectedWarehouse,
  filter: (wh) => wh !== null,
  fn: (wh) => Number(wh),
  target: toggleSelectWarehouse,
});
sample({
  clock: warehouseModel.$allWarehouses.updates,
  source: {
    status: ViewerGate.status,
    allWh: warehouseModel.$allWarehouses,
    isZoomEnabled: $zoomModeEnabled,
  },
  filter: ({ status, isZoomEnabled }) => status && !isZoomEnabled,
  fn: ({ allWh }) => {
    // console.log('updates');
    return allWh;
  },
  target: drawStoresOnMap,
});
sample({
  clock: $selectedWarehouseId.updates,
  filter: (whId) => Boolean(whId),
  fn: (whId) => {
    return Number(whId);
  },
  target: [warehouseModel.fetchWarehouseByIdFx, fetchWarehouseStatByIdFx],
});
sample({
  clock: warehouseModel.$warehouseInfo.updates,
  source: {
    status: ViewerGate.status,
    initialZoomEnabled: $initialZoomEnabled,
    initialZoomCompleted: $initialZoomCompleted,
    whInfo: warehouseModel.$warehouseInfo,
  },
  filter: ({ initialZoomEnabled, initialZoomCompleted, status, whInfo }) =>
    status &&
    !initialZoomCompleted &&
    initialZoomEnabled &&
    whInfo?.type === warehouseModel.WAREHOUSE_TYPES.sleeve,
  fn: (arg1, arg2) => {
    // if (arg1.whInfo) console.log('arg1', JSON.stringify(arg1.whInfo.bags));
    // if (arg2) console.log('arg2', JSON.stringify(arg2.bags));
    return true;
  },
  target: [toggleZoomMode, $initialZoomCompleted],
});
sample({
  clock: toggleSelectWarehouse,
  source: warehouseModel.$allWarehouses,
  fn: (warehouses, id) => warehouses.find((wh) => wh.id === id)?.type ?? null,
  target: $selectedWarehouseType,
});
sample({
  clock: toggleSelectWarehouse,
  source: { mode: $selectedViewMode, zoomEnabled: $zoomModeEnabled },
  filter: ({ mode, zoomEnabled }) => zoomEnabled && mode.value === 'list',
  fn: () => false,
  target: toggleZoomMode,
});
sample({
  clock: removeWarehouseFeatureModel.submit,
  fn: () => false,
  target: toggleZoomMode,
});
sample({
  clock: warehouseModel.$warehouseInfo.updates,
  source: {
    status: ViewerGate.status,
    whInfo: warehouseModel.$warehouseInfo,
    zoomEnabled: $zoomModeEnabled,
  },
  filter: ({ status, whInfo, zoomEnabled }) => status && zoomEnabled && whInfo !== null,
  fn: ({ whInfo }, arg2) => {
    // console.log('whInfo after update', whInfo);
    // if (arg2) console.log('arg2', JSON.stringify(arg2));
    return whInfo as IWarehouseWithBags;
  },
  target: onZoomUpdate,
});
sample({
  clock: ViewerGate.close,
  target: warehouseModel.resetWarehouseInfo,
});
